import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import { Provider } from 'react-redux';
import { store } from './store/store';
import Header from './components/Header';
import AuthInitializer from './components/AuthInitializer';
import ProtectedRoute from './components/ProtectedRoute';
import UploadPage from './pages/UploadPage';
import EngineerPortal from './pages/EngineerPortal';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CustomerLoginPage from './pages/CustomerLoginPage';
import CustomerDashboard from './pages/CustomerDashboard';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <AuthInitializer>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
              <Header />
              <Box component="main" sx={{ flexGrow: 1 }}>
                <Routes>
                  <Route path="/" element={<UploadPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/engineer" element={<EngineerPortal />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/customer/login" element={<CustomerLoginPage />} />
                  <Route
                    path="/customer/dashboard"
                    element={
                      <ProtectedRoute requiredAuth="customer">
                        <CustomerDashboard />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Box>
            </Box>
          </AuthInitializer>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;